module.exports = __webpack_public_path__ + "static/img/8.8313815.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imges/scheme/8.jpg
// module id = KT2b
// module chunks = 1